<template>
    <dashboard-page title="Trafx" subtitle="Arquivos de registro Trafx">
    <div class="content no-icon-shape">
        <base-header class="pb-6">
            <b-row align-h="start" class="mb-3">
                <b-col align-self="start" sm="6" md=3 class="mb-1">
                    <date-picker v-model="formDate.startDate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100" :clearable="false">
                    </date-picker>
                </b-col>

                <b-col align-self="end" md=3 sm="6" class="mb-1">
                    <date-picker v-model="formDate.endDate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100" :clearable="false">
                    </date-picker>
                </b-col>

                <b-col md="3">
                    <base-button class="w-100 mb-1" @click="getUploads" :loading="isLoading" type="primary">Buscar</base-button>
                </b-col>

                <b-col md="3">
                    <base-button class="w-100 mb-1" title="Enviar arquivo Trafx" @click="openModalUpload" :loading="isLoading" type="primary">
                        <i class="fas fa-file-upload"></i>
                        Enviar arquivo
                    </base-button>
                </b-col>
            </b-row>
        </base-header>

        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <b-card footer-classes="pb-2">
                        <div>
                            <b-table :items="trafxFiles" :fields="trafxFilesFields" :busy="isLoading" :sort-by="'date'" :sortDesc="true" empty-text="Sem arquivos de registro Trafx."
                                show-empty small>

                                <template #table-busy>
                                    <div class="text-center my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Carregando...</strong>
                                    </div>
                                </template>

                                <template #cell(date)="data">
                                    {{  formatDate(data.item.date) }} a {{  formatDate(data.item.end) }}
                                </template>

                                <template #cell(name)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(records)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(serial)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(total)="data">
                                    {{ data.value }}
                                </template>

                            </b-table>
                        </div>
                    </b-card>
                    <b-card footer-classes="pb-2" v-if="false">
                        <div>
                            <b-table :items="files" :fields="trafxTableFields" :busy="isLoading" :sortDesc="true" empty-text="Sem arquivos de registro Trafx."
                                show-empty small>

                                <template #table-busy>
                                    <div class="text-center my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Carregando...</strong>
                                    </div>
                                </template>

                                <template #cell(date)="data">
                                    {{ formatDate(data.value) }}
                                </template>

                                <template #cell(entries)="data">
                                    {{ data.value.length }}
                                </template>

                                <template #cell(id)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(mode)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(name)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(placeUuid)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(prodUuid)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(records)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(serial)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(total)="data">
                                    {{ data.value }}
                                </template>

                            </b-table>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <TrafxModalUpload :openModal="openModal" @closeModal="closeModalUpload" @successOnUpload="getUploads()"></TrafxModalUpload>

    </div>
    </dashboard-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import moment from "moment"
import { DatePicker } from "element-ui"
import TrafxModalUpload from "./TrafxModalUpload"

export default {
    name: "TrafxPage",

    components:{
        DatePicker,
        TrafxModalUpload,
    },

    data() {
        return {
            openModal: false, formDate: { startDate: "", endDate: "" },
            trafxFiles: [],
            trafxFilesFields: [
                { key: "date", label: "Período", sortable: true }, 
                { key: "name", label: "Atrativo", sortable: true }, 
                { key: "records", label: "Trafx Record ID", sortable: true },
                { key: "serial", label: "Trafx Nº Serial", sortable: true },
                { key: "total", label: "total de registros", sortable: true },
            ],
            trafxTableFields: [
                { key: "date", label: "Dt. Início", sortable: true }, 
                { key: "entries", label: "Entradas", sortable: true }, 
                { key: "id", label: "ID", sortable: true }, 
                { key: "mode", label: "mode", sortable: true }, 
                { key: "name", label: "Nome", sortable: true }, 
                { key: "placeUuid", label: "placeUuid", sortable: true }, 
                { key: "prodUuid", label: "prodUuid", sortable: true }, 
                { key: "records", label: "Records", sortable: true },
                { key: "serial", label: "Nº Serial", sortable: true },
                { key: "total", label: "total de registros", sortable: true },
            ]
        }
    },
    
    computed: {
        ...mapGetters('trafx',{
            files: 'getTrafxFiles',
            isLoading: 'getIsLoading'
        }),
    },
    methods: {
        ...mapActions('trafx', [
            "fetchTrafxFiles"
        ]),

        fillsFormDate() {
            let first = moment().subtract(7, 'days')
            let last = moment().add(7, 'days')
            
            this.formDate.startDate = first.format('YYYY-MM-DD')
            this.formDate.endDate = last.format('YYYY-MM-DD')
        },

        formatDate(date){ return moment(date).format("L") },

        openModalUpload(){ this.openModal = true },
        closeModalUpload(){ this.openModal = false },

        async getUploads(){ 
            await this.fetchTrafxFiles({start_date:  '', end_date: '' })
            this.trafxFiles = this.groupByRecords()
         },

        groupByRecords() {
            const grouped = this.files.reduce((acc, file) => {
                const key = file.records; 

                if (!acc[key]) {
                acc[key] = [];
                }

                acc[key].push(file);
                return acc;
            }, {})
            const groupedArray = Object.entries(grouped).map(([records, items, date, end, name, record, serial,total]) => { 
                date = items.reduce((prev, current) => {
                    if(prev.date){
                        prev = prev.date
                    }
                    return prev < current.date ? prev : current.date
                })

                if(date.date){
                    date = date.date
                }
                end = items.reduce((prev, current) => {
                    if(prev.date){
                        prev = prev.date
                    }
                    return prev > current.date ? prev : current.date
                })

                if(end.date){
                    end = end.date
                }

                name = items[0]['name']
                record = items[0]['records']
                serial = items[0]['serial']
                total = items.reduce((prev, curr) => {
                    if(prev.total){
                        prev = prev.total
                    }
                    return prev + curr.total
                },0)
                return { records, items, date, end, name, record, serial,total} 
            })
            .sort((a, b) => new Date(a.date) - new Date(b.date));
            console.log('groupedArray :>> ', groupedArray);
            return groupedArray;
        }
    },
    
    async mounted() {
        await this.getUploads()
    },

}
</script>